export enum ThemeMode {
  LIGHT = 'light-theme',
  DARK = 'dark-theme',
}
